import { NgModule, ModuleWithProviders, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    withInterceptorsFromDi,
    provideHttpClient
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';

import { AppConfig, APPCONFIG } from './configs/app-config';
import { HttpInterceptor } from './interceptors/http-interceptor';
import { TranslationLoader } from './translations/translation-loader';
import { SessionService } from './services';
import { NavbarModule } from './navbar/navbar.module';
import { TranslationService } from './translations/translation.service';
import { OngoingRequestTrackingInterceptor } from './interceptors/ongoing-request-tracking-interceptor.service';
import { AttributionComponent } from './attribution/attribution.component';
import { SharedModule } from "@shared";

@NgModule({
    exports: [BrowserModule, BrowserAnimationsModule, NavbarModule],
    declarations: [
        AttributionComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslationLoader,
                deps: [HttpClient, CookieService]
            },
            isolate: true
        }),
        ToastrModule.forRoot({
            closeButton: true,
            easeTime: 450
        }),
        SharedModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OngoingRequestTrackingInterceptor,
            multi: true
        },
        provideAppInitializer(() => {
        const initializerFn = ((sessionService: SessionService) => () => sessionService.init())(inject(SessionService));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        const initializerFn = ((translationService: TranslationService) => () => translationService.init())(inject(TranslationService));
        return initializerFn();
      }),
        CookieService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class CoreModule {
    public static forRoot(config: AppConfig): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [{ provide: APPCONFIG, useValue: config }]
        };
    }
}
